export default __webpack_public_path__ + "static/media/Ice Hauler.fc1133f6.png";